import { ApiClientError } from "./client";
import { ProApiClientError } from "./pro-api.client";

/** Extract a user-visible message from pro-api or user-service client errors. */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof ApiClientError || error instanceof ProApiClientError) {
    return error.message || fallback;
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
}
